export const iconFontAwesomeArrowsArrowDown = (
	<i className="fa-solid fa-arrow-down"></i>
);
